import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "form-field center" }
const _hoisted_3 = { class: "form-field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Status", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: true }, "Rentable", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: false }, "Unrentable", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "col"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Updating ")
const _hoisted_11 = {
  key: 1,
  class: "col"
}

import { ref } from "vue";
import BaseModal from "@/components/BaseModal.vue";
import BaseSpinner from "@/components/BaseSpinner.vue";
import api from "@virgodev/bazaar/functions/api";


export default /*#__PURE__*/_defineComponent({
  props: {
  unitName: {
    type: String,
    required: true,
  },
  unitStatus: {
    type: Boolean,
    required: true,
  },
  unitId: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  emits: ["modalClosed"],
  setup(__props, { emit }) {

const props = __props

const formSubmitting = ref(false);
const formErrors = ref<Record<string, string[]>>({});


const formFields = ref({
  unit: {
    rentable: ref(props.unitStatus),
  },
});

async function submitForm() {
  const json = JSON.parse(JSON.stringify(formFields.value));
  formErrors.value = {};
  formSubmitting.value = true;
  let url = `unit_status/?id=${props.unitId}&facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "PATCH",
    json,
  });

  formSubmitting.value = false;

  if (responseData.status === 200) {
    emit("modalClosed");
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref: "modalRef",
    onModalClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('modalClosed')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", null, _toDisplayString(__props.unitName) + " Unit Status", 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(submitForm, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFields.value.unit.rentable) = $event)),
              class: "form-select"
            }, _hoisted_7, 512), [
              [_vModelSelect, formFields.value.unit.rentable]
            ])
          ]),
          _createElementVNode("button", {
            disabled: formSubmitting.value,
            type: "submit",
            class: "btn btn-text"
          }, [
            (formSubmitting.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(BaseSpinner)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, "Update"))
          ], 8, _hoisted_8)
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 512))
}
}

})